export const ACCOUNT_SET_STATUS_META = {
  draft: {
    badgeClass: "admin-badge-neutral",
    label: "Draft",
  },
  pending_review: {
    badgeClass: "admin-badge-warning",
    label: "Pending",
  },
  reconnect_required: {
    badgeClass: "admin-badge-warning",
    label: "Reconnect Required",
  },
  active: {
    badgeClass: "admin-badge-success",
    label: "Active",
  },
  deleted: {
    badgeClass: "admin-badge-danger",
    label: "Deleted",
  },
};

export function resolveAccountSetRowStatus(accountSet, fallbackStatus = "active") {
  if (fallbackStatus === "deleted") return "deleted";

  const rawStatus = typeof accountSet?.linkStatus === "string" ? accountSet.linkStatus.trim() : "";

  if (rawStatus) return rawStatus;

  return accountSet?.symbolsLocked || accountSet?.futureSymbol || accountSet?.spotSymbol
    ? "active"
    : "draft";
}
